//Core
import React from "react"

//Components
import SwipeableViews from "react-swipeable-views"

//Styles
import style from "./style.module.scss"

const tutorialSteps = [
  {
    text: `В додатку Wallet натиснути плюсик 
        у верхньому правовому куті`,
  },
  {
    text: `Відсканувати картку або ввести ПІП та дані ПК вручну`,
  },
  {
    text: `Погодитися з умовами ДКБО`,
  },
  {
    text: `Ввести деталі картки`,
  },
  {
    text: `Вітаємо!`,
  },
]

const SwipBox = ({ handleStepChange, activeStep }) => {
  return (
    <div className={style.swip_box}>
      <SwipeableViews
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        ignoreNativeScroll={true}
      >
        {tutorialSteps.map((step, index) => (
          <div key={step.text.toString()} className={style.slider}>
            {Math.abs(activeStep - index) <= 2 ? (
              <div className={style.text}>{step.text}</div>
            ) : null}
          </div>
        ))}
      </SwipeableViews>
    </div>
  )
}

export default SwipBox
